export default __webpack_public_path__ + "assets/images/dice-ec3f14b2734a24ec499c7823c544aa6f.svg";